import { ResponseObject } from "../models/ResponseObject";
import { fileServiceConfig } from "./AxiosConfig";

const uploadFile = async (
    fileData:FormData,
    successCallback: (fileUploadData: ResponseObject) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await fileServiceConfig.post("/Vendor/", fileData);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

export const FileUploadService = {
    uploadFile,
  };
  